import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { Field, reduxForm, change, getFormValues } from 'redux-form';
import { withRouter } from 'react-router-dom';
// import 'react-dates/initialize';
// import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';

import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';
import { products } from '../../services';
import { InputDate, ButtonField } from '../../lib/forms';
import  Pagination from '../Pagination/Pagination';
import CallItems from './CallItems';
import Heading from '../Heading/Heading';

class CallDetailsForm extends Component{
  constructor() {
    super();
    this.send = this.send.bind(this)
    this.state = {
      startDate: moment()
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount(){
    window.jQuery('#buttons-collapse').hide();
    this.props.changeFieldValue()
  }
  send(value) {
    this.props.changeFieldValue('value', value)
    setTimeout(() => { this.props.handleSubmit() }, 500)
  }
  handleChange(date) {
    this.setState({
      startDate: date
    });
  }
  render() {
    const { data, callDetailsValue, translate } = this.props;
    const classNameForButtons = (data["hasMissedCalls"] && data["hasReceivedCalls"]) ? 'col-md-4' : 'hidden';
    return (
      <div className="service-action" >
        <div className="card card-service-action">
        {Heading(translate('call-details'),PhoneNumberFormat(data.phoneNumber))}
        <div className="">
          <div className="mispari-card-block">
        <form className="form-group">
          <div className="form-group row">
            <div className="form-text form-group" ><span >{translate('call-details-subtitle')}</span></div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group row">
                <label className="col-3 col-form-label font-weight-bold">{translate('from')}</label>
                <div className="col-8">
                <Field name="start" label="nom"  component={InputDate}  className="form-control" type="date"  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group row">
                <label className="col-3 col-form-label font-weight-bold">{translate('to')}</label>
                <div className="col-8">
                <Field name="end" label="nom" placeholder="DD/MM/YYYY" component={InputDate}  className="form-control" type="date"  />
                </div>

              </div>

            </div>
            <div className="col-md-4">
              <div className="form-group row">
                <div className="col-12"  onClick={() => window.jQuery('#buttons-collapse').show()}>
                  <Field name="go" className="btn btn-primary form-control" callDetailsValue={callDetailsValue} component={ButtonField} type="button" val='go' title={translate('call-details-go-button')}  onclick={this.send}  />
                </div>
            </div>
          </div>

          </div>

        </form>
      </div>
    </div>

      <div className="collapsed" id="buttons-collapse" aria-expanded="false" >
        <div className="row">
          <div className={classNameForButtons}>
            <Field name="received" label="nom" callDetailsValue={callDetailsValue} component={ButtonField} type="button" val='received' title={translate('received')} onclick={this.send} />
          </div>
          <div className={classNameForButtons}>
            <Field name="emitted" label="nom" callDetailsValue={callDetailsValue} component={ButtonField} type="button" val='emitted' title={translate('outgoing-calls')} onclick={this.send} />
          </div>
          <div className={classNameForButtons}>
            <Field name="missed" label="nom" callDetailsValue={callDetailsValue} component={ButtonField} type="button" val='missed' title={translate('missed')} onclick={this.send} />
          </div>
        </div>
        </div>
      </div>
      </div>
    )
  }
}


const viewMapStateToProps = (state) => {
  if (state.form.callDetails){
    return {
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      callDetailsValue: state.form.callDetails.values.value,
      values: getFormValues('callDetails')(state) ||{},
    }
  }
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    changeFieldValue: (field, value) => {
      dispatch(
        change('callDetails', field, value)
      );
    },
  };
};
CallDetailsForm = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(CallDetailsForm);

CallDetailsForm = reduxForm({
 form: 'callDetails',
 initialValues: {'value':'received', "start": moment().subtract(1, 'days'), "end": moment()}
})(CallDetailsForm)


class CallDetailsFormHandler extends Component {
  constructor(){
    super()
    this.state = {
      data: '',
      totalPages: '',
      calls: '',
      values: '',
    };
  }
  componentDidMount(){
    const { rest } = this.props;
    const ProductId = rest.computedMatch.params.userProductId;
    products.getProduct(ProductId)
      .then((res) => {
        this.setState({
          data: res.body.data.userProduct.Data,
        });
      });
  }
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }
  onRouteChanged() {
    const { rest } = this.props;
    const ProductId = rest.computedMatch.params.userProductId;
    products.getCallDetails(ProductId, this.state.values, rest.computedMatch.params.page)
      .then((res) => {
        this.setState({
          calls: res.body.data.Consumption.calls,
        });
      })
      .catch(err => {
        console.log(err);
      })
  }

  // FIXME: Need to move the setState to a dispatch, to avoid from changing state inside a render
  // Ideal solution would be to write a new reducer (Check with Shmulik)
  handleSubmit(values) {
    const { rest } = this.props;
    const ProductId = rest.computedMatch.params.userProductId;
    return products.getCallDetails(ProductId, values, rest.computedMatch.params.page)
        .then(res => {
      this.setState({
        totalPages: res.body.meta["total-pages"],
        values: values,
        calls: res.body.data.Consumption.calls,
      });
      })
      .catch(err => {
        console.log(err);
      })
    }
  render() {
        const { rest } = this.props;
        const pagination = this.state.totalPages > 1 ? Pagination(this.state.totalPages, rest.computedMatch.params.page): "";
    return (
      <div className="card card-service-action">
        <div className="card-block" id='services-line-detail'>
        <CallDetailsForm onSubmit={this.handleSubmit.bind(this)}  rest={this.props.rest} data={this.state.data} />
        <CallItems calls={this.state.calls} />
        {pagination}
        </div>
      </div>
    );
  }
}
CallDetailsFormHandler = withRouter(CallDetailsFormHandler);
export default CallDetailsFormHandler;



// WEBPACK FOOTER //
// ./src/components/CallDetails/CallDetails.js